import { useUiStore } from "../stores/uiStore";

export function getB2BMode() {
  return useUiStore.getState().isB2BMode;
}

export function setB2BMode(enabled) {
  useUiStore.getState().setB2BMode(enabled);
}

export function useB2BMode() {
  const isB2BMode = useUiStore((state) => state.isB2BMode);
  const enableB2BMode = useUiStore((state) => state.enableB2BMode);
  const disableB2BMode = useUiStore((state) => state.disableB2BMode);

  return { isB2BMode, enableB2BMode, disableB2BMode };
}
